import {NgModule} from '@angular/core';
import {LoginComponent} from './login/login.component';
import {SharedModule} from "../../common/shared.module";
import {CanvaComponent} from "../../components/canva/canva.component";
// import {ForgotPasswordComponent} from "./forgot-password/forgot-password.component";
// import {BusinessRenameComponent} from "./business-rename/business-rename.component";
// import {ChangePasswordComponent} from "./change-password/change-password.component";

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        LoginComponent,
        CanvaComponent
    ],
    exports: [
        LoginComponent,
        CanvaComponent
    ]
})

export class StartModule {
}
